import { css } from "lit";

export const styles = css`
  :host {
    display: block;
    font-family: var(--sds-typography-family-body);
    width: 100%;
  }

  .color-picker-container {
    display: flex;
    flex-direction: column;
    gap: var(--sds-size-space-600);
    width: 100%;
  }

  /* Visual picker container - groups canvas and slider with no gap */
  .visual-picker-container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  .color-picker-title {
    font-size: var(--sds-typography-body-size-medium);
    font-weight: var(--sds-typography-weight-semibold);
    color: var(--sds-color-text-default-default);
    margin: 0 0 var(--sds-size-space-400) 0;
  }

  /* 2D Color Canvas */
  .color-canvas-container {
    position: relative;
    width: 100%;
    height: 150px;
    border-radius: var(--sds-size-radius-400);
    overflow: visible;
    cursor: crosshair;
    user-select: none;
  }

  .color-canvas {
    width: 100%;
    height: 100%;
    border-radius: var(--sds-size-radius-400);
    cursor: crosshair;
    display: block;
    box-sizing: border-box;
  }

  .canvas-cursor {
    position: absolute;
    width: 12px;
    height: 12px;
    border: 2px solid var(--sds-color-white-1000);
    border-radius: var(--sds-size-radius-full);
    pointer-events: none;
    transform: translate(-50%, -50%);
    box-shadow: 0 0 var(--sds-size-depth-100) var(--sds-color-black-400);
    z-index: 1;
  }

  /* 1D Hue Slider */
  .hue-slider-container {
    position: relative;
    width: 100%;
    height: 20px;
  }

  .hue-slider {
    width: 100%;
    height: 100%;
    background: linear-gradient(
      to right,
      hsl(0deg 100% 50%) 0%,
      hsl(60deg 100% 50%) 16.66%,
      hsl(120deg 100% 50%) 33.33%,
      hsl(180deg 100% 50%) 50%,
      hsl(240deg 100% 50%) 66.66%,
      hsl(300deg 100% 50%) 83.33%,
      hsl(360deg 100% 50%) 100%
    );
    cursor: pointer;
  }

  .hue-cursor {
    position: absolute;
    top: -2px;
    width: 4px;
    height: 24px;
    background-color: var(--sds-color-white-1000);
    border: var(--sds-size-stroke-border) solid var(--sds-color-border-default-default);
    border-radius: var(--sds-size-radius-200);
    pointer-events: none;
    transform: translateX(-50%);
    box-shadow: 0 var(--sds-size-depth-025) var(--sds-size-depth-200) var(--sds-color-black-300);
    z-index: 1;
  }

  /* Input Container */
  .input-container {
    display: flex;
    padding: 0 16px 16px;
    flex-direction: column;
    gap: 8px;
  }

  /* Hex Input */
  wow-input {
    width: 100%;
  }

  /* Error Message */
  .error-message {
    font-size: var(--sds-typography-body-size-small);
    color: var(--sds-color-text-danger-default);
    margin-top: var(--sds-size-space-200);
  }

  /* Responsive Design */
  @media (max-width: 768px) {
    .color-canvas-container {
      height: 135px;
    }
  }

  /* Touch-friendly adjustments */
  @media (pointer: coarse) {
    .color-canvas {
      cursor: pointer;
    }

    .hue-slider {
      cursor: pointer;
    }

    .canvas-cursor {
      width: 14px;
      height: 14px;
    }

    .hue-cursor {
      width: 6px;
      height: 26px;
    }
  }
`;
